// Google Analytics utilities
// The gtag script is loaded in index.html

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// Track page views (for single-page app navigation)
export const trackPageView = (path) => {
  if (window.gtag) {
    window.gtag('config', 'G-Y57SMHTQV0', {
      page_path: path,
    });
  }
};

// Track gateway installations
export const trackGatewayInstall = (source) => {
  trackEvent('gateway_install_started', {
    event_category: 'Gateway',
    event_label: source,
  });
};

// Track beta program signups
export const trackBetaSignup = (email) => {
  trackEvent('beta_signup', {
    event_category: 'User',
    event_label: 'Beta Program',
  });
};

// Track gateway registration
export const trackGatewayRegistration = (gatewayId) => {
  trackEvent('gateway_registered', {
    event_category: 'Gateway',
    event_label: gatewayId,
  });
};

// Track user login
export const trackLogin = (method = 'email') => {
  trackEvent('login', {
    method: method,
  });
};

// Track user signup
export const trackSignup = (method = 'email') => {
  trackEvent('sign_up', {
    method: method,
  });
};

